import React from 'react';
import { Link } from 'react-router';

const AppButton = ({ icon, label, children, to }) => (
  <Link to={to} className='appButtonContainer'>
    <div className='appButton' style={{ backgroundImage: `url(${icon})` }}>

      { label }
    </div>
    <div className='caption'>
      { children }
    </div>
  </Link>
);

export default AppButton;
